import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { LightboxProps } from "@/types/modules/post/components";
import Image from "next/image";

export const Lightbox: React.FC<LightboxProps> = ({ isOpen, onClose, images = [], initialImageIndex = 0 }) => {
  let [currentImageIndex, setCurrentImageIndex] = useState(initialImageIndex >= 0 ? initialImageIndex : 0);

  function nextImage() {
    if (currentImageIndex + 1 > images.length - 1) {
      setCurrentImageIndex(0);
    } else {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  }

  function prevImage() {
    if (currentImageIndex - 1 < 0) {
      setCurrentImageIndex(images.length - 1);
    } else {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  }

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[9999999]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-dark bg-opacity-90 backdrop-blur-md" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="relative flex min-h-full flex-col items-center justify-center p-6 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative flex h-full w-full flex-1 transform items-center justify-center text-left align-middle transition-all">
                {images && images[currentImageIndex] && (
                  <figure className="flex w-4/5 max-w-[1560px] flex-col items-stretch justify-center">
                    <Image
                      className="max-h-[calc(100vh-140px)] w-full object-contain"
                      src={images[currentImageIndex].src}
                      alt=""
                      width={1200}
                      height={800}
                    />
                    {(images[currentImageIndex].caption ||
                      images[currentImageIndex].source ||
                      images[currentImageIndex].author) && (
                      <figcaption className="mt-2 !px-0 font-sans text-2xs text-white sm:text-md">
                        {images[currentImageIndex].caption}
                        {(images[currentImageIndex].source || images[currentImageIndex].author) && (
                          <p className="mt-2 font-sans text-xsDescription font-light text-white-70">
                            {images[currentImageIndex].author || images[currentImageIndex].source}
                          </p>
                        )}
                      </figcaption>
                    )}
                  </figure>
                )}

                {images.length > 1 && (
                  <>
                    <button
                      className="absolute left-0 h-[48px] w-[48px] rounded-full bg-dark-50 bg-[url('/assets/images/icons/chevron-left-light.svg')] bg-center bg-no-repeat hover:bg-white hover:bg-[url('/assets/images/icons/chevron-left.svg')]"
                      type="button"
                      onClick={prevImage}
                    />
                    <button
                      className="absolute right-0 h-[48px] w-[48px] -scale-x-100 rounded-full bg-dark-50 bg-[url('/assets/images/icons/chevron-left-light.svg')] bg-center bg-no-repeat hover:bg-white hover:bg-[url('/assets/images/icons/chevron-left.svg')]"
                      type="button"
                      onClick={nextImage}
                    />
                  </>
                )}

                <button
                  className="absolute right-0 top-0 mt-12 h-[48px] w-[48px] -scale-x-100 rounded-full bg-dark-50 bg-[url('/assets/images/icons/times-white.svg')] bg-center bg-no-repeat hover:bg-white hover:bg-[url('/assets/images/icons/times.svg')] md:mt-0"
                  type="button"
                  onClick={onClose}
                />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
